<script lang="ts" setup>
import type {
  CarDetailsImage,
  DetailsCarItemDetails,
} from '../../../../../types/components/CarDetails'
import { generateImageSizesFromArray } from '@autobid/ui/utils/car/generateImageSizes'

interface Props {
  information: DetailsCarItemDetails['information']
  gallery: CarDetailsImage[]
}

const props = defineProps<Props>()
const mainImages = generateImageSizesFromArray(
  'hd',
  props.gallery.slice(0, 2),
).map(el => el.links.l)
</script>

<template>
  <SectionsDetailsPdfElementsHeading as="td">
    {{ $t('car-details.section.information') }}
  </SectionsDetailsPdfElementsHeading>

  <tr>
    <td>
      <table class="w-full border-collapse">
        <tr>
          <td style="width: 33%" class="align-top">
            <img
              v-for="(img, index) in mainImages"
              :key="img"
              :data-src="img"
              alt=""
              :class="{ 'mb-2': index !== mainImages.length - 1 }"
            >
            <table v-if="!mainImages.length" class="w-full border-collapse">
              <tr>
                <td class="h-48" style="border: 1px solid #e5e7eb">
                  <ElementsCarThumbnailPlaceholder />
                </td>
              </tr>
            </table>
          </td>
          <td style="width: 66%" class="pl-4">
            <SectionsDetailsElementsParameters :parameters="information" />
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>
